module.exports = __webpack_public_path__ + "static/media/snow_specification.5eeeba25.md";